import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = () => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  console.log('👤 ProtectedRoute: user =', user);
  console.log('📄 profile =', profile);
  console.log('📍 location.pathname =', location.pathname);

  const publicPaths = ['/', '/login', '/register'];

  // Don't render anything until loading finishes
  if (loading) return null;

  // If no user and trying to access a protected route
  if (!user && !publicPaths.includes(location.pathname)) {
    return <Navigate to="/" replace />;
  }

  // If user is not fully setup (welcome stage)
  if (user?.isSetupComplete === false && location.pathname !== '/welcome') {
    return <Navigate to="/welcome" replace />;
  }

  // Wait until profile is loaded before making a redirect decision
  if (user?.isSetupComplete && profile === null) {
    // Still fetching account setup status
    return null;
  }

  // If user setup is incomplete (onboarding stage)
  if (user?.isSetupComplete && profile?.accountSetupComplete === false && location.pathname !== '/accountsetup') {
    return <Navigate to="/accountsetup" replace />;
  }

  // Prevent setup-complete user from returning to account setup
  //  if (profile?.accountSetupComplete && location.pathname === '/accountsetup') {
  //    return <Navigate to="/dashboard/testreports" replace />;
  //  }

  // Replaced above to account for users that have success or cancel through Stripe
  // ✅ Allow Stripe return URLs like /accountsetup?status=success or ?status=cancel
  const isReturningFromStripe =
    location.pathname === '/accountsetup' && location.search.includes('status=');

  if (profile?.accountSetupComplete && profile?.status !== 'new' && location.pathname === '/accountsetup' && !isReturningFromStripe) {
    return <Navigate to="/dashboard/testreports" replace />;
  }

  // Redirect fully setup user away from setup-related pages
  //  if (
  //    user?.isSetupComplete &&
  //    profile?.accountSetupComplete &&
  //    ['/', '/welcome', '/accountsetup'].includes(location.pathname)

  // Replaced above to account for users that have success or cancel through Stripe
  if (
    user?.isSetupComplete &&
    profile?.accountSetupComplete &&
    ['/', '/welcome'].includes(location.pathname)
// End of replaced code
  ) {
    return <Navigate to="/dashboard/testreports" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
